import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Button, Grid, IconButton, Modal, Typography } from "@mui/material";
import { MdLocationPin } from "react-icons/md";
import { PALETTE } from "../Theme/Palette";
import { GET_HODA_INFO } from "../api";
import { ReactComponent as Logo1 } from "../assets/images/Logo_1.svg";
import { FaPhoneAlt } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";

const Footer = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);

  const { data: hoda_info } = useQuery(["GET_HODA_INFO"], () => GET_HODA_INFO.get());

  return (
    <Grid container bgcolor={{ xs: "#fff", sm: "#FAFAFA", md: "#FAFAFA" }}>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid
          minWidth={{ xs: "85%", sm: "35%" }}
          borderRadius="10px"
          padding="0 1rem 1rem 0"
          bgcolor="#fff"
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Grid width="100%" display="flex" flexDirection="row" p="0.3rem">
            <IconButton onClick={() => setOpenModal(false)}>
              <RxCross2 />
            </IconButton>
          </Grid>
          <Grid width="100%" mb={1} display={{ xs: "none", sm: "inline-block" }}>
            <Typography variant="h1" fontSize="1.4rem" textAlign="center">
              تماس با ما
            </Typography>
          </Grid>
          <Grid
            container
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            alignItems="center"
          >
            <Grid
              xs={4}
              display="flex"
              justifyContent="flex-start"
              boxSizing="border-box"
              pl={{ sm: 5, xl: 10 }}
            >
              <Logo1
                style={{
                  width: "80px",
                  height: "130px",
                }}
              />
            </Grid>
            <Typography
              variant="h1"
              fontSize="1.4rem"
              textAlign="center"
              display={{ sm: "none" }}
              mt={2}
              mb={2}
            >
              تماس با ما
            </Typography>
            <Grid xs={12} sm={8} display="flex" flexDirection="column" alignItems="center">
              <Grid width="100%" display="flex" flexDirection="column" alignItems="flex-end">
                <Grid
                  width="100%"
                  display="flex"
                  flexDirection="row-reverse"
                  justifyContent="flex-start"
                  alignItems="center"
                  mb={2}
                >
                  <MdLocationPin
                    fontSize="1.1rem"
                    style={{
                      paddingLeft: "0.4rem",
                    }}
                    color={`${PALETTE.eightth}`}
                  />
                  <Typography variant="h4" sx={{ direction: "rtl" }}>
                    آدرس : {hoda_info?.data?.data?.address}
                  </Typography>
                </Grid>
                <Grid
                  width="100%"
                  display="flex"
                  flexDirection="row-reverse"
                  justifyContent="flex-start"
                  alignItems="center"
                >
                  <FaPhoneAlt
                    fontSize="1rem"
                    style={{
                      paddingLeft: "0.4rem",
                    }}
                    color={`${PALETTE.eightth}`}
                  />
                  <Typography variant="h4" sx={{ direction: "rtl" }}>
                    تلفن : {hoda_info?.data?.data?.landPhoneNumber}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Modal>
      <Grid container display="flex" justifyContent={{ xs: "space-between", md: "row" }}>
        <Button
          variant="s1"
          sx={{
            boxSizing: "border-box",
            borderRadius: { xs: 0, md: "0 22.7px 0 0" },
            width: { xs: "50%", md: "auto" },
            padding: { xs: "1.2rem", md: "1rem" },
          }}
          onClick={() => setOpenModal(true)}
        >
          تماس با ما
        </Button>
        <Button
          variant="s1"
          sx={{
            boxSizing: "border-box",
            background: "linear-gradient(90deg, #ED304D 5.82%, #03009F 132.42%)",
            borderRadius: { xs: 0, md: "22.7px 0 0 0" },
            width: { xs: "50%", md: "auto" },
            padding: { xs: "1.2rem", md: "1rem" },
            borderLeft: "1px solid #fff",
          }}
          onClick={() => navigate("/about-us")}
        >
          درباره ی ما
        </Button>
      </Grid>
    </Grid>
  );
};

export default Footer;
